"use client";
import { setClientUserAttributes as C } from "./server-entry-fec7344c.js";
import { lazy as t, createContext as e } from "react";
const s = t(() => import("./button-36cacb47.js")), r = t(() => import("./columns-597b4a0e.js")), i = t(() => import("./fragment-1492bc7f.js")), a = t(() => import("./image-d87761af.js")), c = t(() => import("./section-d83e2dd3.js")), m = t(() => import("./symbol-93b85799.js")), l = t(() => import("./text-5915f038.js")), p = t(() => import("./video-52df64e2.js")), u = t(() => import("./blocks-729e6331.js").then((o) => o.blocks)), d = t(() => import("./content-variants-78e04173.js").then((o) => o.contentVariants)), x = e({
  content: null,
  context: {},
  localState: void 0,
  rootSetState() {
  },
  rootState: {},
  apiKey: null,
  apiVersion: void 0,
  componentInfos: {},
  inheritedStyles: {},
  BlocksWrapper: "div",
  BlocksWrapperProps: {},
  nonce: "",
  model: ""
});
export {
  u as Blocks,
  x as BuilderContext,
  s as Button,
  r as Columns,
  d as Content,
  i as Fragment,
  a as Image,
  c as Section,
  m as Symbol,
  l as Text,
  p as Video,
  C as setClientUserAttributes
};
